import Collection from './Collection';

export default Collection;
export { Collection };